import { useMemo } from 'react';
import {
  GridColDef,
  GridSlotsComponentsProps,
} from '@mui/x-data-grid-pro';
import { InspectionOnTableView } from 'presentation/inspection/inspectionOnView';

interface UseInspectionDataGridSlotPropsOptions {
  columns: GridColDef<InspectionOnTableView>[];
}

export function useInspectionDataGridSlotProps({
  columns,
}: UseInspectionDataGridSlotPropsOptions): GridSlotsComponentsProps {
  return useMemo(
    () => ({
      columnsManagement: {
        disableShowHideToggle: false,
        disableResetButton: true,
        getTogglableColumns: () => columns.map((column) => column.field),
      },
      loadingOverlay: {
        variant: 'skeleton',
        noRowsVariant: 'skeleton',
      },
      basePopper: {
        placement: 'bottom-end',
      },
      baseTextField: { variant: 'outlined', size: 'small' },
      baseSelect: { variant: 'outlined', size: 'small' },
    }),
    [columns]
  );
}
